/* eslint-disable camelcase */
type User = {
  title: string;
  email: string;
  name: string;
  university_code: string;
  advisor: string;
  cmkl_id: string;
  first_name: string;
  first_term: string;
  id: string;
  last_name: string;
  last_term: string;
  nickname: string;
  role: string;
};

// export const DummyUser: User = {
//   name: 'Visarut',
//   lastname: 'Techatanachai
//   picture: 'https://picsum.photos/200',
// };

export const EmptyUser: User = {
  title: '',
  name: '',
  email: '',
  university_code: '',
  advisor: '',
  cmkl_id: '',
  first_name: '',
  first_term: '',
  id: '',
  last_name: '',
  last_term: '',
  nickname: '',
  role: '',
};

export default User;
